import React from 'react';
import { ArrowLeft } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
import { TestOpenAI as TestOpenAIComponent } from '../components/TestOpenAI';

function TestOpenAIPage() {
  const navigate = useNavigate();
  
  return (
    <div className="min-h-screen bg-gray-50 p-6">
      <div className="max-w-2xl mx-auto">
        <div className="flex items-center mb-6">
          <button
            onClick={() => navigate(-1)}
            className="p-2 rounded-full hover:bg-gray-200 transition-colors mr-2"
          >
            <ArrowLeft className="h-5 w-5" />
          </button>
          <h1 className="text-2xl font-semibold text-gray-800">OpenAI API Test</h1>
        </div>
        
        <div className="mb-6">
          <p className="text-gray-600">
            Use this page to test if the OpenAI API is correctly configured for your helpdesk chat function.
            This can help diagnose issues with the helpdesk functionality.
          </p>
        </div>
        
        <TestOpenAIComponent />
        
        <div className="mt-8 p-4 bg-blue-50 rounded-xl border border-blue-200">
          <h3 className="text-lg font-medium text-blue-800 mb-2">Troubleshooting Tips</h3>
          <ul className="space-y-2 text-blue-700 text-sm">
            <li>
              <strong>API Key Issue:</strong> If the test fails with an authentication error, check if your 
              OpenAI API key is correctly set in the Supabase edge function secrets.
            </li>
            <li>
              <strong>Assistant Not Found:</strong> Verify that the assistant ID is correct and the assistant 
              exists in your OpenAI account.
            </li>
            <li>
              <strong>Edge Function Deployment:</strong> Ensure the helpdesk-chat function is properly deployed 
              using the deploy-helpdesk.sh script.
            </li>
            <li>
              <strong>Check Logs:</strong> Run <code className="bg-blue-100 px-1 rounded">supabase functions logs helpdesk-chat</code> to 
              see detailed error messages from the function execution.
            </li>
          </ul>
        </div>
      </div>
    </div>
  );
}

export default TestOpenAIPage;